<template>
  <div
    class="tag-container"
    :class="getTagClass"
    @click="onTagClick"
    @keydown.space.stop="onTagClick"
    tabindex="0"
    data-test="data-tag"
  >
    <slot />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ isSelected: boolean }>();
const emit = defineEmits(["on-tag-click"]);

const getTagClass = computed(() => {
  return props.isSelected ? "tag-selected" : "tag-unselected";
});

function onTagClick() {
  emit("on-tag-click");
}
</script>

<style scoped lang="less">
@import (reference) "../styles/bootstrap/variables.less";
.tag-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 100vmax;
  width: max-content;
  white-space: nowrap;
  border: 1px solid #ddd;
  padding: 0.5rem 2rem;
  transition: background-color 0.3s ease;

  &:hover {
    cursor: pointer;
  }
}

.tag-selected {
  background-color: @charismatic-color;
  color: #ffffff;
}

.tag-unselected {
  background-color: @body-bg;
  color: @off-black;
}
</style>
